// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-gallery-jsx": () => import("./../../../src/pages/gallery.jsx" /* webpackChunkName: "component---src-pages-gallery-jsx" */),
  "component---src-pages-purchase-jsx": () => import("./../../../src/pages/purchase.jsx" /* webpackChunkName: "component---src-pages-purchase-jsx" */),
  "component---src-templates-landing-page-jsx": () => import("./../../../src/templates/LandingPage.jsx" /* webpackChunkName: "component---src-templates-landing-page-jsx" */)
}

